function difference(a1, a2) {
  let a2Set = new Set(a2);
  return a1.filter(function (x) {
    return !a2Set.has(x);
  });
}

const Utils = {
  valida_cpf_cnpj: (valor) => {
    var valida = verifica_cpf_cnpj(valor);

    valor = valor.toString();

    if (valida === "CPF") {
      return valida_cpf(valor.replace(/[^0-9]/g, ""));
    } else if (valida === "CNPJ") {
      return valida_cnpj(valor);
    }

    // Não retorna nada
    else {
      return false;
    }
  },
  // retorna elementos diferentes entre dois arrays
  arrayDiference: (arrayA, arrayB) => {
    return difference(arrayA, arrayB).concat(difference(arrayB, arrayA));
  },

  // retorna elementos iguais entre dois arrays
  arrayInterseccao: (arrayA, arrayB) => {
    return arrayA.filter((x) => arrayB.includes(x));
  },

  validaCPF: (cpf) => {
    let strCPF = cpf
      .replace(/\./g, "")
      .replace(/\-/g, "")
      .replace(/\(/g, "")
      .replace(/\)/g, "")
      .replace(/\//g, "")
      .replace(/\s/g, "");

    var Soma;
    var Resto;
    Soma = 0;

    if (strCPF === "00000000000") return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  },
};

export default Utils;


////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
/*
 verifica_cpf_cnpj
 
 Verifica se é CPF ou CNPJ
 
 @see http://www.todoespacoonline.com/w/
*/

function verifica_cpf_cnpj(valor) {
  valor = valor.toString();
  var raw = valor.replace(/[^a-zA-Z0-9]/g, "");

  if (/[a-zA-Z]/.test(raw)) {
    return "CNPJ";
  }

  if (raw.length === 11) {
    return "CPF";
  } else if (raw.length === 14) {
    return "CNPJ";
  }

  return false;
} // verifica_cpf_cnpj

/*
 calc_digitos_posicoes
 
 Multiplica dígitos vezes posições
 
 @param string digitos Os digitos desejados
 @param string posicoes A posição que vai iniciar a regressão
 @param string soma_digitos A soma das multiplicações entre posições e dígitos
 @return string Os dígitos enviados concatenados com o último dígito
*/
function calc_digitos_posicoes(digitos, posicoes = 10, soma_digitos = 0) {
  // Garante que o valor é uma string
  digitos = digitos.toString();

  // Faz a soma dos dígitos com a posição
  // Ex. para 10 posições:
  //   0    2    5    4    6    2    8    8   4
  // x10   x9   x8   x7   x6   x5   x4   x3  x2
  //   0 + 18 + 40 + 28 + 36 + 10 + 32 + 24 + 8 = 196
  for (var i = 0; i < digitos.length; i++) {
    // Preenche a soma com o dígito vezes a posição
    soma_digitos = soma_digitos + digitos[i] * posicoes;

    // Subtrai 1 da posição
    posicoes--;

    // Parte específica para CNPJ
    // Ex.: 5-4-3-2-9-8-7-6-5-4-3-2
    if (posicoes < 2) {
      // Retorno a posição para 9
      posicoes = 9;
    }
  }

  // Captura o resto da divisão entre soma_digitos dividido por 11
  // Ex.: 196 % 11 = 9
  soma_digitos = soma_digitos % 11;

  // Verifica se soma_digitos é menor que 2
  if (soma_digitos < 2) {
    // soma_digitos agora será zero
    soma_digitos = 0;
  } else {
    // Se for maior que 2, o resultado é 11 menos soma_digitos
    // Ex.: 11 - 9 = 2
    // Nosso dígito procurado é 2
    soma_digitos = 11 - soma_digitos;
  }

  // Concatena mais um dígito aos primeiro nove dígitos
  // Ex.: 025462884 + 2 = 0254628842
  var cpf = digitos + soma_digitos;

  // Retorna
  return cpf;
} // calc_digitos_posicoes

/*
 Valida CPF
 
 Valida se for CPF
 
 @param  string cpf O CPF com ou sem pontos e traço
 @return bool True para CPF correto - False para CPF incorreto
*/
function valida_cpf(valor) {
  // Garante que o valor é uma string
  valor = valor.toString();

  // Remove caracteres inválidos do valor
  valor = valor.replace(/[^0-9]/g, "");

  // Captura os 9 primeiros dígitos do CPF
  // Ex.: 02546288423 = 025462884
  var digitos = valor.substr(0, 9);

  // Faz o cálculo dos 9 primeiros dígitos do CPF para obter o primeiro dígito
  var novo_cpf = calc_digitos_posicoes(digitos);

  // Faz o cálculo dos 10 dígitos do CPF para obter o último dígito
  var novo_cpf = calc_digitos_posicoes(novo_cpf, 11);

  // Verifica se o novo CPF gerado é idêntico ao CPF enviado
  if (novo_cpf === valor) {
    // CPF válido
    return true;
  } else {
    // CPF inválido
    return false;
  }
} // valida_cpf

/*
 valida_cnpj
 
 Valida se for um CNPJ
 
 @param string cnpj
 @return bool true para CNPJ correto
*/
// IN RFB 2.229/2024 — CNPJ alfanumérico: posições 1-12 aceitam A-Z e 0-9
function valida_cnpj(valor) {
  valor = valor.toString().replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  if (valor.length !== 14) return false;
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(valor)) return false;

  var pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  var pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  function charVal(c) { return c.charCodeAt(0) - 48; }

  function calcDV(chars, pesos) {
    var soma = 0;
    for (var i = 0; i < pesos.length; i++) soma += charVal(chars[i]) * pesos[i];
    var resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  }

  var dv1 = calcDV(valor, pesos1);
  if (parseInt(valor[12]) !== dv1) return false;
  var dv2 = calcDV(valor.substring(0, 12) + dv1, pesos2);
  return parseInt(valor[13]) === dv2;
} // valida_cnpj

/*
 valida_cpf_cnpj
 
 Valida o CPF ou CNPJ
 
 @access public
 @return bool true para válido, false para inválido
*/





// valida_cpf_cnpj

/*
 formata_cpf_cnpj
 
 Formata um CPF ou CNPJ

 @access public
 @return string CPF ou CNPJ formatado
*/
function formata_cpf_cnpj(valor) {
  var formatado = false;
  var valida = verifica_cpf_cnpj(valor);
  valor = valor.toString();

  if (valida === "CPF") {
    valor = valor.replace(/[^0-9]/g, "");
    if (valida_cpf(valor)) {
      formatado = valor.substr(0, 3) + ".";
      formatado += valor.substr(3, 3) + ".";
      formatado += valor.substr(6, 3) + "-";
      formatado += valor.substr(9, 2);
    }
  } else if (valida === "CNPJ") {
    valor = valor.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    if (valida_cnpj(valor)) {
      formatado = valor.substr(0, 2) + ".";
      formatado += valor.substr(2, 3) + ".";
      formatado += valor.substr(5, 3) + "/";
      formatado += valor.substr(8, 4) + "-";
      formatado += valor.substr(12, 2);
    }
  }

  return formatado;
} // formata_cpf_cnpj
